import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { NumberInputContainer, NumberButton, NumberTextField } from './CreateCouponStyles'

interface NumberInputProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  disabled?: boolean
  hasError?: boolean
}

const NumberInput: React.FC<NumberInputProps> = ({ 
  value, 
  onChange, 
  min = 0, 
  max = 10000,
  disabled = false,
  hasError = false 
}) => {
  const handleIncrement = () => {
    if (!disabled && value < max) onChange(value + 1)
  }

  const handleDecrement = () => {
    if (!disabled && value > min) onChange(value - 1)
  }

  return (
    <NumberInputContainer>
      <NumberButton
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        size="small"
      >
        <RemoveIcon sx={{ fontSize: 12 }} />
      </NumberButton>
      <NumberTextField
        value={value}
        onChange={(e) => {
          const val = parseInt(e.target.value) || 0
          if (val >= min && val <= max) onChange(val)
        }}
        disabled={disabled}
        hasError={hasError}
        inputProps={{ style: { textAlign: 'center' } }}
      />
      <NumberButton
        onClick={handleIncrement}
        disabled={disabled || value >= max}
        size="small"
      >
        <AddIcon sx={{ fontSize: 12 }} />
      </NumberButton>
    </NumberInputContainer>
  )
}

export default NumberInput